import { PaginationResponse } from "types";
import http from "../index";
import {
  CreateUploadFilesInput,
  FileListParams,
  FileRecord,
  UpdateFileGroupInput,
} from "./types";

export const IMAGE_EXTENSIONS = new Set([
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".webp",
  ".jfjf",
]);

export function isPreviewableImage(extension?: string) {
  if (!extension) {
    return false;
  }
  return IMAGE_EXTENSIONS.has(extension.toLowerCase());
}

namespace file_manage {
  export const getGroupNameList = async () => {
    return http.get<string[]>(`file_manage/groups`, {
      hasAuth: true,
    });
  };

  export const getFileList = async (body: FileListParams) => {
    return http.post<PaginationResponse<FileRecord>>("file_manage/paginate", {
      hasAuth: true,
      body,
    });
  };

  export const uploadLocationImage = async (file: File | Blob) => {
    const formData = new FormData();
    formData.append("file", file);
    return http.post<FileRecord>("file_manage/location/upload", {
      hasAuth: true,
      body: formData,
    });
  };

  export const createUploadFiles = async (body: CreateUploadFilesInput) => {
    const formData = new FormData();
    formData.append("group_name", body.group_name || "");
    formData.append("bucket_name", body.bucket_name);
    for (const file of body.files) {
      formData.append("files", file);
    }

    return http.post<FileRecord[]>("file_manage/create", {
      hasAuth: true,
      body: formData,
    });
  };

  export const updateFileGroup = async (
    id: number,
    body: UpdateFileGroupInput
  ) => {
    return http.put<FileRecord>(`file_manage/update/${id}`, {
      hasAuth: true,
      body,
    });
  };

  export const deleteFileWithMinio = async (id: number) => {
    return http.del<FileRecord>(`file_manage/delete/${id}`, {
      hasAuth: true,
    });
  };

  export const downloadFile = async (url: string, filename: string) => {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Org-Id": localStorage.getItem("org") || "",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    const downloadUrl = globalThis.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    globalThis.URL.revokeObjectURL(downloadUrl);
  };
}

export default file_manage;
